import { render, staticRenderFns } from "./DeliveryLight.vue?vue&type=template&id=4f77420a&"
import script from "./DeliveryLight.vue?vue&type=script&lang=js&"
export * from "./DeliveryLight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DeliveryLight.vue"
export default component.exports